import {GET_TRANSLATIONS_START, GET_TRANSLATIONS_SUCCESS, GET_TRANSLATIONS_FAILURE, SET_CURRENT_LANGUAGE, RESET_REDUX} from "../../actions/actionTypes";
import getConfig from "../../environment";
import {getSubdomain} from "../../helpers/getSubdomain";

const subdomain = getSubdomain();
console.log('--- in translationsReducer, subdomain = ', subdomain);
const initialTranslations =  subdomain !== '' ? require(`../../assets/translations/${subdomain}-translations.json`) : require(`../../assets/translations/translations.json`);

const availableLangs = initialTranslations?.availableLanguages?.map(lang => {return lang.code}) || ['en'];
console.log('--- in translationsReducer, available langs = ', availableLangs);

/** TODO once service for translations is available, remove pt from collected languages in initialState */
const initialState = {
  currentLanguage: initialTranslations.language,
  collectedLanguages: availableLangs,
  translations: initialTranslations.translations,
  availableLanguages: initialTranslations.availableLanguages,
  loading: false,
  errors: null
};

const translationsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_CURRENT_LANGUAGE: {
      return {
        ...state,
        currentLanguage: action.payload.lang,
      }
    }
    case GET_TRANSLATIONS_START: {
      return {
        ...state,
        loading: true,
      }
    }
    case GET_TRANSLATIONS_SUCCESS: {
      console.log('action payload = ', action.payload.currentLanguage);
      return {
        ...state,
        currentLanguage: action.payload.currentLanguage,
        collectedLanguages: action.payload.collectedLanguages,
        availableLanguages: action.payload.availableLanguages,
        translations:action.payload.translations,
        loading: false,
        errors: null
      }
    }
    case GET_TRANSLATIONS_FAILURE: {
      return {
        ...state,
        errors: action.payload.errors
      }
    }
    case RESET_REDUX: {
      return {
        ...initialState
      }
    }
    default: {
      return state;
    }
  }
};

export default translationsReducer;
